<script setup>
import SpotListWindlist from '@/components/SpotListWindlist.vue';
</script>

<template>
  <div class="jwx-page">
    <div class="jwx-page__container" data-section-gap="true">
      <SpotListWindlist />
    </div>
  </div>
</template>